<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form :form="form" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-item label="所属年级" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag
                  placeholder="请输入所属年级"
                  v-decorator="['gradeId']"
                  dict="school_grade,grade_name,id,delete_flag=0"
                  :async="false"
                  style="width: 100%"
                ></j-search-select-tag>
              </a-form-item>
            </a-col>

            <a-col :span="24">
              <a-form-item label="学生图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-image-upload
                  ref="faceIds"
                  isMultiple
                  v-decorator="['faceIds']"
                  :bizPath="'headImg/' + tenantId"
                ></j-image-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { TENANT_ID } from '@/store/mutation-types'
import Vue from 'vue'

export default {
  name: 'UpdateStudentFaceModal',
  components: {
    JFormContainer,
    JImageUpload,
    JSearchSelectTag,
  },
  data() {
    return {
      title: '批量更新学生照片',
      width: 800,
      visible: false,
      disableSubmit: false,
      form: this.$form.createForm(this),
      tenantId: Number(Vue.ls.get(TENANT_ID)),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      url: {
        batchUpdateStudentFace: '/aigoes/studentInfo/batchUpdateStudentFace',
      },
    }
  },
  methods: {
    show() {
      this.form.resetFields()
      this.model = Object.assign({}, {})
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'classId', 'faceIds'))
      })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.visible = false
    },
    handleOk() {
      this.submitForm()
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.faceIds = this.$refs['faceIds'].fileList.map((file) => {
            return { name: file.oldName, pic: file.response.message }
          })
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          // return
          httpAction(this.url.batchUpdateStudentFace, formData, 'post')
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                if (res.result && res.result.includes('重名')) {
                  that.$message.warning({
                    content: res.result, 
                    duration: 0 // 设置为0表示不自动消失，需用户手动关闭
                  })
                }
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
